import React, { useState } from 'react';
// @ts-ignore
import uuid from 'uuid';

// @ts-ignore
import { FormGroupField } from 'components/Form';

import { SRow, SAddUtteranceButton, SPlusIcon } from './styled';

type Props = {
  onAddUtterance: (utterance: { id: string; utterance: string }) => void;
};

const CreateNewUtterance = ({ onAddUtterance }: Props) => {
  const [utterance, setUtterance] = useState('');

  const addUtteranceButtonIsDisabled = !utterance.trim();

  const updateUtterance = () => {
    onAddUtterance({
      id: uuid(),
      utterance: utterance.trim(),
    });

    setUtterance('');
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setUtterance(e.target.value);

  const onKeyDown = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();

    if (utterance.trim() && e.key === 'Enter') {
      e.preventDefault();

      updateUtterance();
    }
  };

  return (
    <React.Fragment>
      <SRow>
        <FormGroupField
          input={{ name: 'training-utterances', value: utterance }}
          label="TRAINING UTTERANCES"
          name="utterance"
          placeholder="Type a typical utterance that maps to this intent..."
          type="text"
          onChange={onChange}
          onKeyDown={onKeyDown}
        />

        <SAddUtteranceButton
          data-test="add-utterance-button"
          disabled={addUtteranceButtonIsDisabled}
          type="button"
          onClick={updateUtterance}
        >
          <SPlusIcon>+</SPlusIcon>
          <span>Add</span>
        </SAddUtteranceButton>
      </SRow>
    </React.Fragment>
  );
};

export default CreateNewUtterance;
